import AppProvider from "./providers/AppProvider";
import UserProvider from "./providers/UserProvider";
import { Provider } from "react-redux";
import store from "./store/index";
import { ToastProvider } from "@octano/global-ui";
import AppRouter from "./Router";
import PortalConfigProvider from "./providers/PortalConfigProvider";

function App() {
  return (
    <PortalConfigProvider>
      <Provider store={store}>
        <ToastProvider>
          <AppProvider>
            <UserProvider>
              <AppRouter />
            </UserProvider>
          </AppProvider>
        </ToastProvider>
      </Provider>
    </PortalConfigProvider>
  );
}

export default App;
